import { APP_ROUTES, normalizeAppPath } from './routes';

export function sanitizeNextPath(rawPath) {
  return normalizeAppPath(rawPath);
}

export function getPostAuthRedirect(location) {
  const stateFrom = location?.state?.from;
  if (typeof stateFrom === 'string') {
    return sanitizeNextPath(stateFrom) || APP_ROUTES.dashboard;
  }
  if (stateFrom && typeof stateFrom === 'object' && typeof stateFrom.pathname === 'string') {
    const search = typeof stateFrom.search === 'string' ? stateFrom.search : '';
    const hash = typeof stateFrom.hash === 'string' ? stateFrom.hash : '';
    return sanitizeNextPath(`${stateFrom.pathname}${search}${hash}`) || APP_ROUTES.dashboard;
  }
  const nextParam = new URLSearchParams(location?.search || '').get('next');
  return sanitizeNextPath(nextParam) || APP_ROUTES.dashboard;
}

export function buildAuthLink(pathname, nextPath) {
  const nextPathname = normalizeAppPath(pathname) || pathname;
  const sanitizedNext = sanitizeNextPath(nextPath);
  if (!sanitizedNext) return nextPathname;
  const params = new URLSearchParams({ next: sanitizedNext });
  return `${nextPathname}?${params.toString()}`;
}